/**
 * 日志级别
 */
export var LogLevel;
(function (LogLevel) {
    /**
     * 日志
     */
    LogLevel["INFO"] = "info";
    /**
     * 成功日志
     */
    LogLevel["SUCCESS"] = "success";
    /**
     * 接口问题导致的错误
     * 不影响用户使用的边缘 case
     * 非核心功能问题
     */
    LogLevel["WARNING"] = "warning";
    /**
     * 严重错误
     */
    LogLevel["ERROR"] = "error";
    // DEBUG = 'debug', 暂时去掉，目前和 info 重合，后面按需加
})(LogLevel || (LogLevel = {}));
/**
 * 日志动作，描述消费日志的行为
 */
export var LogAction;
(function (LogAction) {
    /**
     * 输出到浏览器控制台
     */
    LogAction["CONSOLE"] = "console";
    /**
     * 持久化，即上报至平台
     */
    LogAction["PERSIST"] = "persist";
})(LogAction || (LogAction = {}));
